// extracted by mini-css-extract-plugin
export var fadeInOut = "_2t-3";
export var icon = "_2t-4";
export var savedIndicator = "_2t-2";
export var savingIndicator = "_2t-0";
export var spin = "_2t-1";